import { render } from "./global-payment-methods-settings.vue?vue&type=template&id=a91e60fe&ts=true"
import script from "./global-payment-methods-settings.ts?vue&type=script&lang=ts"
export * from "./global-payment-methods-settings.ts?vue&type=script&lang=ts"

import "./global-payment-methods-settings.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__